import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HpNoticeComponent } from './hp-notice/hp-notice.component';
import { HpCategoriesComponent } from './hp-categories/hp-categories.component';
import { HpSliderComponent } from './hp-slider/hp-slider.component';
import { HpMediaComponent } from './hp-media/hp-media.component';
import { StoreModule } from "@ngrx/store";
import { bannerSearchFeatureKey, bannerSearchReducer } from "@app/reducers/homepage/banner.reducer";
import { EffectsModule } from "@ngrx/effects";
import { BannerEffect } from "@app/effects/homepage/banner.effect";
import { PdtCateEffect } from "@app/effects/shoppingmall/pdt-cate.effect";
import { NoticeEffect } from "@app/effects/myoffice/notice/notice.effects";
import { noticeSearchFeatureKey, noticeSearchReducer } from "@app/reducers/myoffice/notice/notice.reducer";
import { PopBoardEffect } from "@app/effects/homepage/pop-board.effect";
import { popBoardFeatureKey, popBoardReducer } from "@app/reducers/homepage/pop-board.reducer";
import { ComponentsModule } from "@app/components/components.module";
import { HpFeaturesComponent } from './hp-features/hp-features.component';
import { HpAboutUsComponent } from './hp-about-us/hp-about-us.component';
import { HpRegisterComponent } from './hp-register/hp-register.component';
import { NgxPaginationModule } from "ngx-pagination";
import { PipeModule } from "@app/pipes/pipe.module";
import { RouterModule } from "@angular/router";
import { BoardPopupComponent } from './board-popup/board-popup.component';
import { HpBestComponent } from './hp-best/hp-best.component';
import { HpProductComponent } from './hp-product/hp-product.component';
import { HpBrandComponent } from './hp-brand/hp-brand.component';
import { HpPickComponent } from './hp-pick/hp-pick.component';
import { HpReviewsComponent } from './hp-reviews/hp-reviews.component';
import { HpPromotionComponent } from './hp-promotion/hp-promotion.component';

@NgModule({
    declarations: [        
        HpNoticeComponent,
        HpCategoriesComponent,
        HpSliderComponent,
        HpMediaComponent,
        HpFeaturesComponent,
        HpAboutUsComponent,
        HpRegisterComponent,
        BoardPopupComponent,
        HpBestComponent,
        HpProductComponent,
        HpBrandComponent,
        HpPickComponent,
        HpReviewsComponent,
        HpPromotionComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        NgxPaginationModule,
        PipeModule,
        RouterModule,
        StoreModule.forFeature(bannerSearchFeatureKey, bannerSearchReducer),
        StoreModule.forFeature(noticeSearchFeatureKey, noticeSearchReducer),
        StoreModule.forFeature(popBoardFeatureKey, popBoardReducer),
        EffectsModule.forFeature([BannerEffect, NoticeEffect, PopBoardEffect])
    ],
    exports: [
        HpNoticeComponent,
        HpCategoriesComponent,
        HpSliderComponent,
        HpMediaComponent,
        HpFeaturesComponent,
        HpAboutUsComponent,
        HpRegisterComponent,
        BoardPopupComponent,
        HpBestComponent,
        HpProductComponent,
        HpBrandComponent,
        HpPickComponent,
        HpReviewsComponent,
        HpPromotionComponent
    ]
})
export class HomeIndexModule { }